import { TAB_LINK_CLASS_NAME, NAVBAR_ROUTE_CLASS_NAME, NAVBAR_LINK_CLASS_NAME, NAVBAR_PROFILE_CLASS_NAME } from '../../constants/link';
import { ITAU_FONT_TEXT, ITAU_BASE_FONT_SIZE } from '../fonts';
import fingoMuiLink, { underlineTabLink } from '../../fingo/components/MuiLink';

const navbarRoute = ({ theme }) => ({
  color: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.common.white,
    textDecoration: 'underline',
  },
  '&.active': {
    color: theme.palette.common.white,
    textDecoration: 'underline',
  },
});

const navbarProfile = ({ theme }) => ({
  border: `1px solid ${theme.palette.common.white}`,
  borderRadius: 8,
  padding: '8px 8px',
  width: 172,
  justifyContent: 'flex-start',
  color: theme.palette.common.white,
  fontWeight: 500,
  fontSize: ITAU_BASE_FONT_SIZE,
  fontFamily: ITAU_FONT_TEXT,
  textDecoration: 'none',
});

const navbarLink = ({ theme }) => ({
  height: '24px',
  color: theme.palette.common.white,
  fontFamily: ITAU_FONT_TEXT,
  fontSize: ITAU_BASE_FONT_SIZE,
  fontWeight: 500,
  lineHeight: 1.2,
  textDecorationColor: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.common.white,
    textDecorationColor: theme.palette.common.white,
  },
});

const tabLink = ({ theme }) => {
  const fingoUnderlineTabLink = (
    underlineTabLink({ theme, accentColor: theme.palette.secondary.main })
  );
  return {
    ...fingoUnderlineTabLink,
    '& .MuiTypography-subNavItem': {
      ...fingoUnderlineTabLink['& .MuiTypography-subNavItem'],
      fontWeight: 600,
      lineHeight: '26px',
    },
  };
};

const MuiLink = {
  styleOverrides: {
    root: ({ theme }) => {
      const base = fingoMuiLink.styleOverrides.root({ theme });
      return {
        ...base,
        [`&.${TAB_LINK_CLASS_NAME}`]: {
          ...base[`&.${TAB_LINK_CLASS_NAME}`],
          ...tabLink({ theme }),
        },
        [`&.${NAVBAR_ROUTE_CLASS_NAME}`]: {
          ...base[`&.${NAVBAR_ROUTE_CLASS_NAME}`],
          ...navbarRoute({ theme }),
        },
        [`&.${NAVBAR_PROFILE_CLASS_NAME}`]: {
          ...base[`&.${NAVBAR_PROFILE_CLASS_NAME}`],
          ...navbarProfile({ theme }),
        },
        [`&.${NAVBAR_LINK_CLASS_NAME}`]: {
          ...base[`&.${NAVBAR_LINK_CLASS_NAME}`],
          ...navbarLink({ theme }),
        },
      };
    },
  },
};

export default MuiLink;
